import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import OrderSummary from '../order-summary/OrderSummary';
import OrderTotals from '../order-totals/OrderTotals';
// styles
import styles from './sidebar.scss';

export class Sidebar extends PureComponent {

  static propTypes = {
    isDeliveryPage: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object),
    partnerDiscountEnabled: PropTypes.bool,
  };

  static defaultProps = {
    isDeliveryPage: false,
    items: undefined,
    partnerDiscountEnabled: false,
  };

  render() {
    const {
      isDeliveryPage,
      items,
      partnerDiscountEnabled,
    } = this.props;

    return (
      <div
        className={styles.container}
        data-test="sidebar-container"
      >
        <div className={styles.innerContainer}>
          <OrderSummary
            items={items}
            partnerDiscountEnabled={partnerDiscountEnabled}
            sidebarView
          />

          <OrderTotals
            isDeliveryPage={isDeliveryPage}
            sidebarView
          />
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    items: state.orderForm.items,
    partnerDiscountEnabled: state.user.partnerDiscountEnabled,
  };
}

export default connect(state => mapStateToProps(state))(Sidebar);
